/*global dataLayer */

// --------------------------------------------------------------------------
// Generic form toggle functionality used across the site
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var events = require('common-js-pub-sub')();

// jquery plugins
require('../plugins/jquery.validate');
require('../plugins/jquery.validate.unobtrusive');
require('../plugins/expressive.annotations.validate');

var debounce = require('../utilities/debounce');

var $btn;

module.exports = function (options) {
    var context = options.context;

    /// The form
    var $form = context.find('form');

    /// Download pack button
    var $downloadButton = $(context).find('button[name="Download"]');

    /// Post pack button
    var $postButton = $(context).find('button[name="Post"]');

    /// Pack Language Checkbox
    var $languageCheckbox = $(context).find('[data-binding="pack-language-checkbox"]');

    /// Find create account forms ection. Age vailidation determines its visibility on the page
    var $createAccountSection = $('[data-binding="form-section-create-account"]');
    var $dpPreferences = $('[data-binding="form-section-dp-preferences"]');

    /// Used to determine visibility of createAccountSection
    var $ageCheckbox = $(context).find('[data-field-alias="Under18"]');

    /// Is registration mandatory? Set as a bool
    var isRegistrationMandatory = $(context).find('#RegisteringUserDetails_RegistrationMandatory').val() === 'True' ? true : false;

    /// Form is invalid until proven otherwise
    var isFormValid = false;

    /// A default duration for animations/timeouts
    var defaultDuration = 300;

    /// Date Of Birth form group
    var $dobSelection;
    var $underageDisclaimer;

    /// Placeholder for the resgistration message
    var $registrationAgeMessage = $('<span class="field-validation-error"></span>').css({ 'margin-bottom': '10px' });

    /// Placeholder for the invald month message
    var $invalidMonthMessage = $('<span class="field-validation-error"></span>').css({ 'margin-bottom': '10px' });

    /// Break Point
    var formMQ = window.matchMedia('(max-width: 768px)');

    /// show/hide buttons
    var $toggleBtn = context.find('.toggle');

    /**
     * Toggle the 'toggle' button text
     * @param  {object} $toggle The toggle button
     * @param  {string text     'show' || 'hide'
     */
    function toggleButtonText($toggle, text) {
        $toggle.text($toggle.data(text + '-text'));
    }

    /**
     * Scroll to an elements offset
     * @param  {int} offset
     */
    function scrollToElement(offset, duration) {
        $('html, body').animate({
            scrollTop: offset
        }, duration);
    }

    /**
     * Calculate an age by comparing dates
     * @param  {obj} dob  JavaScript Date() object
     * @return {int} age
     */
    function getAgeFromDateOfBirth(dob) {
        var today = new Date();
        var age = today.getFullYear() - dob.getFullYear();

        dob.setFullYear(dob.getFullYear() + age);
        if (dob > today) {
            age--;
        }

        return age;
    }

    /**
     * Check if an age is equal or greater than a minumum
     * Returns true if age is equal or higher than minimum
     * @param  {int} year
     * @param  {int} month
     * @param  {int} day
     * @param  {int} minAge
     * @param  {fn}  callback
     * @return {bool}
     */
    function validateAge(year, month, day, minAge, callback) {
        var dob = new Date(year, month - 1, day);
        var age = getAgeFromDateOfBirth(dob);

        /// Convert day from string to number
        var selectedDay = parseInt(day);

        /**
         * Check day is in month
         * Adapted from http://stackoverflow.com/a/20379380
         */
        var date = new Date(year, month - 1, selectedDay).getDate();
        var dateExists = date === selectedDay;

        /// Run callback if
        if (callback) {
            callback(!dateExists);
        }

        /// Does the day entered exist
        /// and is it a valid age?
        if (dateExists && age >= minAge) {
            return age >= minAge;
        }

        return false;
    }

    /**
     * Main form validation
     * @param  {object} buttonClicked     The button that was clicked (next section, download pack)
     * @param  {[type]} validateAllInputs Should all form elements be validated (true) or just the current section (false)
     * @return {[type]}                   [description]
     */
    function validateForm(buttonClicked, validateAllInputs) {
        var errorCount = 0;

        var formSection = validateAllInputs ? $form : buttonClicked.parents('[data-binding="form-content"]');

        /// Find form fields, exclude those in #ContactLookup as they are validated in contact-lookup.js
        var formFields = formSection.find('input, select').not('#ContactLookup_ContactNumber, #ContactLookup_Postcode');

        var postcodeField = context.find('[data-binding="postcode-lookup-input-field"]');
        var postcodeFieldExists = postcodeField.length > 0;
        var isPostcodeEmpty;
        var manualAddressExists = $('[data-binding="edit-address-fields"]').length > 0;
        var manualAddressDisplay;

        if (postcodeFieldExists) {
            isPostcodeEmpty = postcodeField.val() === '';
        }

        if (manualAddressExists) {

            manualAddressDisplay = $('[data-binding="edit-address-fields"]').css('display');

            /// Is first field of manual address is empty?
            var isPartStreetAddressEmpty = $('[data-binding="address-part-street-address"]').val() === '';

            /// Is the part street address field empty?
            if (isPartStreetAddressEmpty) {
                /// Hide the 'Enter Address Manually Button'
                $('[data-binding="enter-address-manually"]').css('display', 'none');

                /// Show the manual address fields
                $('[data-binding="edit-address-fields"]').css('display', 'block');
            }
        }

        for (var counter = 0; counter < formFields.length; counter++) {
            if (!$form.validate().element(formFields[counter])) {
                errorCount++;
            }
        }

        if (postcodeFieldExists && postcodeField.is(':visible') && isPostcodeEmpty === true && manualAddressDisplay !== 'block') {
            errorCount++;
            postcodeField.siblings('span').removeClass('field-validation-valid').addClass('field-validation-error').text(postcodeField.data('error-message'));
        }

        if (manualAddressExists && manualAddressDisplay === 'block') {
            var fields = $('[data-binding="address-part-street-address"], [data-binding="address-part-town"]');

            for (var fieldCounter = 0; fieldCounter < fields.length; fieldCounter++) {
                if (!context.find('form').validate().element(fields[fieldCounter])) {
                    errorCount++;
                }
            }
        }

        return errorCount;
    }

    /**
     * Validate the form
     * @return {bool} 'true' if no errors || 'false' if errors
     */
    function formSubmitValidation() {

        /// Find sections that have not been validated by the 'Next Section' validation
        var invalidSections = $('[data-binding="form-content"]').not('.is-valid-section');

        /// Show the invalid form sections (so jQuery.validate() can see them )
        invalidSections.slideDown();

        /// Update button text
        toggleButtonText(invalidSections.siblings('.toggle'), 'hide');

        /// Run validation on whole form
        var errorCount = validateForm($(this), true);

        /// Are there invalid fields?
        if (errorCount === 0) {
            /// Set form validatin to true, so we don't come back here again
            isFormValid = true;

            /// Valid
            return true;
        } else {

            $('[data-binding="enter-address-manually"]').css('display', 'none');
            $('[data-binding="edit-address-fields"]').css('display', 'block');

            /// For each invalid section that has not passed 'Next Section' validation
            invalidSections.each(function () {

                var hasErrors = $(this).find('.field-validation-error');

                if (hasErrors.length === 0) {
                    /// Close the section
                    $(this).slideUp(0);

                    /// Update button text
                    toggleButtonText($(this).siblings('.toggle'), 'show');
                }
            });

            /// Scroll to the first error
            events.publish('scroll-to-error');

            /// Invalid
            return false;
        }
    }

    /**
     * Toggle/Reveal Elements
     */

    /**
     * Close the current fieldset
     */
    function closeCurrentFieldset(options) {
        options.fieldset.slideToggle(defaultDuration);

        /// Do we need to update the toggle text?
        if (options.updateToggle) {
            toggleButtonText(options.fieldset.siblings('.toggle'), 'show');
        }
    }

    /**
     * Open the next fieldset
     */
    function openNextFieldset(options) {

        /// Wait for fieldset to close
        setTimeout(function () {

            /// Open the fieldset
            options.fieldset.slideDown(defaultDuration, function () {
                scrollToElement(options.fieldset.parents('[class*="form-section"]').offset().top, 200);
            });
        }, defaultDuration);

        /// Do we need to update the toggle text?
        if (options.updateToggle) {
            /// Update button text
            toggleButtonText(options.fieldset.siblings('.toggle'), 'hide');
        }
    }

    /**
     * Toggle DOB fileds
     * @param  {bool}
     */
    function toggleDobSelection(value) {
        if (value) {
            $dobSelection.slideDown();
            $underageDisclaimer.slideDown();
        } else {
            $dobSelection.slideUp();
            $underageDisclaimer.slideUp();
        }
    }

    /**
     * Toggle visibility of the save details form section
     * Hidden if DOB entered is < 18 and age checkbox is ticked
     */
    function toggleCreateAccountSection() {
        if (options.isUnder18) {
            $createAccountSection.stop().slideUp();
            options.createAccountSectionHidden = true;
        } else {
            $createAccountSection.stop().slideDown(function () {
                /// Ensure the style attribute is removed, as style attr is added by jQuery post-slide
                $(this).removeAttr('style');

                options.createAccountSectionHidden = false;
            });
        }
    }

    function toggleDpPreferences() {
        if (options.isUnder18) {
            $dpPreferences.stop().slideUp(function () {
                options.dpPreferencesHidden = true;
            });
        } else {
            $dpPreferences.stop().slideDown(function () {
                /// Ensure the style attribute is removed, as style attr is added by jQuery post-slide
                $(this).removeAttr('style');
                options.dpPreferencesHidden = false;
            });
        }
    }

    function toggleNextSectionVisibility() {
        if (options.isUnder18) {
            setTimeout(function () {
                $dpPreferences.siblings(':visible').find('[data-binding="next-section"]').last().hide();
            }, 1000);
        } else {
            $dpPreferences.siblings(':visible').find('[data-binding="next-section"]').show();
        }
    }

    /**
     * Toggle month message
     * @param  {bool}
     */
    function toggleInvalidMonthMessage(value) {
        if (value) {
            $invalidMonthMessage.slideDown();
        } else {
            $invalidMonthMessage.slideUp();
        }
    }

    /**
     * Toggle form submit button visibility based on pack availability
     * @param  {bool} downloadAvailable
     * @param  {bool} postAvailable
     */
    function togglePackRequestButtons(downloadAvailable, postAvailable) {
        $downloadButton.css('display', downloadAvailable ? '' : 'none');
        $postButton.css('display', postAvailable ? '' : 'none');
    }

    /**
     * Toggle form submit button visibility based on pack availability
     * when a checkbox is clicked
     * @param  {object} packAvailability
     * @param  {object} checkbox
     */
    function checkboxTogglePackRequestButtons(packAvailability, checkbox) {

        /// Get the pack language from the checkbox
        var packLanguage = checkbox.data('pack-language');

        /// Bind a change event to the checkbox
        checkbox.on('change', function () {

            if (checkbox.is(':checked')) {
                /// Hide buttons depending on availability of language pack
                togglePackRequestButtons(packAvailability['downloadAvailable' + packLanguage], packAvailability['postAvailable' + packLanguage]);
            } else {
                /// Show the buttons depending on default availablity
                togglePackRequestButtons(packAvailability.downloadAvailable, packAvailability.postAvailable);
            }
        });
    }

    /**
     * Check the availability of packs from data attrs in the DOM
     * @param  {object} checkbox Checkbox object
     */
    function checkPackAvailability(checkbox) {

        /// Object of pack availability values
        var packAvailability = $('.submit-details-form-section__button').data();

        /// Toggle the buttons depending on default availablity (English)
        togglePackRequestButtons(packAvailability.downloadAvailable, packAvailability.postAvailable);

        /// Is there a checkbox?
        if (checkbox.length > 0) {
            checkboxTogglePackRequestButtons(packAvailability, checkbox);
        }
    }

    /**
     * Google tag manager function
     */
    function pushSubmissionGaDataLayer(buttonName) {

        var contactPreferences = '';

        context.find('[data-binding="contact-preference"]:checked').each(function () {
            contactPreferences += $(this).siblings('label').find('span').text() + ', ';
        });

        contactPreferences = contactPreferences.substring(0, contactPreferences.length - 2);

        dataLayer.push({ 'category': 'financial', 'completionMethod': buttonName, 'contactPreferences': contactPreferences });
    }

    /**
     * Age Checkbox and Create Account Options
     * Users should not be able to create an account if they indicate they are under 18
     */
    /// Is there $ageCheckbox?
    if ($ageCheckbox.length > 0) {
        /// Verbosely exclude DOB fields when form submitted?
        options.excludeDobFromValidation = true;

        /// Store the users date of birth as its entered
        options.dob = {
            BirthDay: null,
            BirthMonth: null,
            BirthYear: null
        };

        /// Min age to validate against
        options.validAge = 18;

        /// Is the user under 18? (Determined by optional checkbox)
        options.isUnder18 = $ageCheckbox.is(':checked');

        /// Have all the DOB fields been entered yet?
        options.allDatesEntered = false;

        /// Is the age entered valid?
        options.isAgeValid = false;

        /// Get the DOB dom element
        $dobSelection = $(context).find('[data-binding="submit-details-dob"]');
        $underageDisclaimer = $(context).find('[data-binding="submit-details-dob-disclaimer"]');

        /// Invalid month message
        $invalidMonthMessage.text($dobSelection.data('invalid-date')).insertBefore($dobSelection).hide();

        /**
         * Setup $.validator config for validation of selects
         *
         * As their default value in the DOM is 0 (which is technically valid)
         * we need to add a new method to $.validator in order to check the
         * value is not '0' and display a custom validation message
         */
        if ($dobSelection.length > 0) {
            /// There is a DOB Selection
            options.hasDobSelection = true;

            /// Object to populate
            var selectValidationRules = {};

            /// Loop over the selects
            $dobSelection.find('[data-binding="submit-details-date-select"]').each(function () {

                /// Object to populate
                var obj = {};

                /// Get the name from the DOM
                var name = $(this).attr('name');

                /// Add a custom method to the validator
                $.validator.addMethod(name, function (value) {
                    return value !== '0'; /// Return bool (is the value 0 or not)
                }, 'Please select a ' + name.replace('Birth', '')); /// Strip out the 'Birth' prefix

                /// Create a config object, for example: {methodName : true}
                obj[name] = true;

                /// Add it to the validation config for example: elementName : { methodName : true }
                /// 'elementName' needs to match the name attr of the element to validate
                selectValidationRules[name] = obj;
            });

            /// Set the defaults before the validator is used
            $.validator.setDefaults({
                rules: selectValidationRules
            });
        }

        if (isRegistrationMandatory) {
            $registrationAgeMessage.text($dobSelection.data('cannot-register')).insertBefore($ageCheckbox.parents('[data-binding="custom-field"]')).hide();
        }
    }

    /// Is there an account section to show/hide depening on DOB?
    if ($createAccountSection.length > 0) {
        /// Should the age be checked to validate its visiblity?
        options.validateCreateAccountSection = true;

        /// Should it be hidden by default?
        options.createAccountSectionHidden = false;
    }
    /// Is there an account section to show/hide depening on DOB?
    if ($dpPreferences.length > 0) {
        /// Should the age be checked to validate its visiblity?
        options.validateDpPreferencesSection = true;

        /// Should it be hidden by default?
        options.dpPreferencesSectionHidden = false;
    }

    function _init() {

        /**
         * Event Listeners
         */

        context.find('button[type="submit"]').attr('data-gtm', '{}');

        context.on('click', 'button[type="submit"]', function () {

            /// Update global var
            $btn = $(this);

            /// Wait for postback
            setTimeout(function () {

                /// Find the first error
                var $firstError = $form.find('.field-validation-error:visible').first();

                /// If one exists
                if ($firstError.length > 0) {
                    /// Scroll to the first error
                    scrollToElement($firstError.offset().top - 10, 1000);
                }
            }, 200);
        });

        /**
         * Add click event to next section button to toggle sections
         */
        context.on('click', '[data-binding="next-section"]', function (e) {

            e.preventDefault();

            var skipCreateAccountStep;
            var skipDpPreferencesStep;

            if (options.validateCreateAccountSection) {
                /// Is the form on step 2 (Custom Questions)?
                var isCustomQuestionsStep = $(this).parents('[data-binding="form-section-custom-questions"]').length > 0;

                /// Should the next step (Create Account) be skipped?
                skipCreateAccountStep = isCustomQuestionsStep && options.createAccountSectionHidden;
            }

            if (options.validateDpPreferencesSection) {
                /// Is the form on step 2 (Custom Questions)?
                var isCustomQuestionsStep = $(this).parents('[data-binding="form-section-custom-questions"]').length > 0;

                /// Should the next step (Create Account) be skipped?
                skipCreateAccountStep = isCustomQuestionsStep && options.dpPreferencesSectionHidden;
            }

            var $this = $(this);

            var errorCount = validateForm($this, false);

            /// Are there errors?
            if (errorCount === 0) {
                /// Add a class to denote it has been validated by validateForm();
                $this.parents('[data-binding="form-content"]').addClass('is-valid-section');

                /// Close this section
                closeCurrentFieldset({
                    fieldset: $this.parents('[data-binding="form-content"]'),
                    updateToggle: true
                });

                /// Open the next
                openNextFieldset({
                    fieldset: skipCreateAccountStep ? $(this).parents('[class*="form-section"]').next().next().find('[data-binding="form-content"]') : $(this).parents('[class*="form-section"]').next().find('[data-binding="form-content"]'),
                    updateToggle: true
                });
            } else {
                events.publish('scroll-to-error');
            }
        });

        /**
         * Add click event to toggle button to toggle sections
         */
        context.on('click', '.toggle', debounce(function (e) {
            e.preventDefault();

            var $this = $(this);
            var text = $this.text();
            var show = $this.data('show-text');
            var hide = $this.data('hide-text');

            $this.siblings('[data-binding="form-content"]').stop().slideToggle();

            setTimeout(function () {
                if (text === hide) {
                    text = $this.text(show);
                } else {
                    text = $this.text(hide);
                }
            }, defaultDuration);
        }, 100));

        /**
         * Always show form sections / fieldsets
         * on smaller screens
         * @type {Function}
         */
        var resizeHandler = debounce(function () {
            var hideText = $toggleBtn.first().data('hide-text');
            if (formMQ.matches) {
                $('[data-binding="form-content"]').show();
                $toggleBtn.each(function () {
                    $(this).text(hideText);
                });
            }
        }, 250);

        $(window).on('resize', resizeHandler).resize();

        /**
         * Modify the jQuery validator submit handler
         * Change made for Codebase #1106
         */
        $form.data('validator').settings.submitHandler = function (form, e) {

            /// Run validation
            var isValid = formSubmitValidation();

            /// Check if the form has passed validation
            if (!isValid) {
                /// Prevent form submission
                e.preventDefault();
            } else {
                /// Push to GTM
                pushSubmissionGaDataLayer($btn.attr('name'));

                /// Reset the submitHandler so we don't come back in here
                $form.data('validator').settings.submitHandler = undefined;

                /// Wait
                setTimeout(function () {
                    /// Unbind any click events
                    $btn.off('click');

                    /// Trigger a click (to trigger form submission)
                    $btn.trigger('click');

                    /// Prevent button double click
                    $btn.prop('disabled', true);

                    /// Find the loading icon
                    var $loadingIcon = $btn.find('.button__loading');

                    /// Hide elements, but don't take them out of the flow
                    /// to prevent the button collapsing when they are hidden
                    $btn.find('svg, img').not($loadingIcon).css({
                        'visibility': 'hidden'
                    });

                    /// Change button text to the localised version of "Submitting..."
                    var submittingText = 'Submitting...';
                    if (window.location.search.indexOf('language=cy') !== -1) {
                        submittingText = 'Cyflwyno...';
                    }

                    $btn.find('.button__text').text(submittingText);

                    /// Show the spinner
                    $loadingIcon.css({
                        'visibility': 'visible'
                    });
                }, 10);
            }
        };

        /**
         * Add change event to 'under 18' checkbox
         */
        $ageCheckbox.on('change', function () {

            var value = $(this).is(':checked');

            /// Update the option
            options.isUnder18 = value;

            /// Toggle save details section
            toggleCreateAccountSection(value);
            toggleDpPreferences(value);
            toggleNextSectionVisibility();
            /// If the user has acknowledged they are under 18
            /// and registration is not mandatory
            if (options.isUnder18) {
                /// Show the invalid message
                toggleInvalidMonthMessage(options.isAgeValid);
                $('#IsUnder18').val('True');
                $('#RegisteringUserDetails_IsUnder18').val('True');
            } else {
                /// Close the invalid message
                toggleInvalidMonthMessage(false);
                $('#IsUnder18').val('False');
                $('#RegisteringUserDetails_IsUnder18').val('False');
            }

            if (options.hasDobSelection) {
                /// Show/hide the DOB section based on checkbox (shown if user is under 18)
                toggleDobSelection(value);
            }
        });

        /**
         * Add change event to date selection
         */
        $(context).find('[data-binding="submit-details-dob"]').find('select').on('change', function () {

            /// Update the value in dob
            options.dob[$(this).attr('id')] = $(this).val();

            /// Check if all fields have values, update option if true
            options.allDatesEntered = (options.dob.BirthDay && options.dob.BirthMonth && options.dob.BirthYear) !== null;

            /// If all three values are entered
            if (options.allDatesEntered) {
                /// Should the save details section be hidden
                options.isAgeValid = validateAge(options.dob.BirthYear, options.dob.BirthMonth, options.dob.BirthDay, options.validAge, toggleInvalidMonthMessage);
            }
        });

        if ($dobSelection) {
            // update validation on change for under 18s
            $dobSelection.find('[data-binding="submit-details-date-select"]').on('change', function () {
                if (options.isAgeValid === true) {
                    toggleInvalidMonthMessage(true);
                }
            });
        }

        /**
         * Scroll to an element by ID
         *
         * Contains a check for open/close state of parent's form content
         * to open the latter, before scrolling to an element
         */
        context.on('click', '[data-binding="scroll-to-id"]', function (e) {

            e.preventDefault();

            var $this = $(this);

            /// Get the target using it's ID
            var $scrollTarget = $('#' + $this.data('scroll-target'));

            /// If a target was found in the DOM
            if ($scrollTarget.length > 0) {
                /// Get the parent form section
                var $parentSection = $this.parents('[data-binding="form-section-contact-details"]');

                /// Get the child content
                var $parentSectionContent = $parentSection.find('fieldset .submit-details-form-section__content');

                /// If the form section content is closed
                if ($parentSectionContent.css('display') === 'none') {
                    /// Open it
                    $parentSectionContent.slideDown();

                    /// Update button text
                    toggleButtonText($parentSectionContent.siblings('.toggle'), 'hide');
                }

                /// Wait, then scroll
                setTimeout(function () {
                    scrollToElement($scrollTarget.offset().top, 1000);
                }, defaultDuration);
            }
        });

        events.subscribe('scroll-to-error', function () {
            var firstError = context.find('.field-validation-error').first();
            var firstErrorSectionContent = firstError.parents('[data-binding="form-content"]');

            if (firstError.parents('[data-binding="edit-address-fields"]').length > 0) {
                $('[data-binding="edit-address-fields"]').slideDown();
            }

            firstErrorSectionContent.slideDown(defaultDuration, function () {
                scrollToElement(firstError.offset().top - 10, 200); /// Add 10px to prevent the error sticking to the top
            });
        });

        /**
         * Run Functions
         */

        if ($languageCheckbox.length > 0) {
            checkPackAvailability($languageCheckbox);
        }

        /// Should the DOB selection be visible (is the checkbox checked on load)
        if (options.hasDobSelection) {
            toggleDobSelection($ageCheckbox.is(':checked'));
        }

        if (options.isUnder18) {
            toggleCreateAccountSection();
            toggleDpPreferences();
            toggleNextSectionVisibility();
        }
    }

    return {
        init: function init() {

            /**
             * As we are modifying $form.data('validator').settings.submitHandler() above,
             * we need to wait until the document is 'ready', as this behavior may be
             * initialised before jQuery.validate(), making the latter undefined if used
             */
            $(document).ready(function () {
                _init();
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/form-toggle.js
// module id = 214
// module chunks = 0